<div class="row g-5 gx-5">
  <div class="col-md-6">
    <dx-form
      #formBasicData
      labelMode="floating"
      [showColonAfterLabel]="false"
      [formData]="formData"
      [readOnly]="readOnly"
    >
      <dxi-item dataField="name">
        <dxo-label [text]="'COMMON.FIELDS.NAME' | translate"></dxo-label>
        <dxi-validation-rule
          type="required"
          [message]="'VALIDATIONS.NAME-REQUIRED' | translate"
        ></dxi-validation-rule>
      </dxi-item>

      <dxi-item
        dataField="description"
        [editorType]="'dxTextArea'"
        [label]="{ text: ('COMMON.FIELDS.DESCRIPTION' | translate) }"
        [editorOptions]="{
          placeholder: ('COMMON.FIELDS.DESCRIPTION' | translate),
          height: 160
        }"
      ></dxi-item>
    </dx-form>
  </div>

  <div class="col-md-6">
    <div class="publishing-mode-container">
      <div class="publishing-mode-title">
        {{ 'EVENT-PUBLISHING-SETTINGS.OVERVIEW.TITLE' | translate }}
      </div>

      <div
        class="publishing-mode-description"
        [innerHTML]="'EVENT-PUBLISHING-SETTINGS.OVERVIEW.DESCRIPTION' | translate"
      ></div>

      <div class="publishing-mode-form">
        <dx-form
          #formPublishingModeData
          labelMode="floating"
          [showColonAfterLabel]="false"
          [formData]="formData"
          [readOnly]="readOnly"
        >
          <dxi-item
            dataField="publishInCatalog"
            editorType="dxCheckBox"
            cssClass="publishing-checkbox"
            [editorOptions]="{
              text: 'COMMON.FIELDS.PUBLISH-CATALOGUE-CALENDAR' | translate
            }"
          >
            <dxo-label [visible]="false"></dxo-label>
          </dxi-item>

          <dxi-item
            *ngIf="isTenantPublishedToSubscribers"
            dataField="publishToSubscribers"
            editorType="dxCheckBox"
            cssClass="publishing-checkbox"
            [editorOptions]="{
              text: 'COMMON.FIELDS.PUBLISH-TO-SUBSCRIBERS' | translate
            }"
          >
            <dxo-label [visible]="false"></dxo-label>
          </dxi-item>
        </dx-form>
      </div>

      <div class="publishing-mode-share">
        {{ 'EVENT-PUBLISHING-SETTINGS.OVERVIEW.SHARE-INFO' | translate }}
      </div>
    </div>
  </div>
</div>

@if(showDeleteSettingsModal){
  <app-confirmation-dialog
    [height]="'auto'"
    [(showModal)]="showDeleteSettingsModal"
    (submit)="deleteEventPublishingSettings()"
    [options]="modalDeleteSettingsConfirmationOptions"
  ></app-confirmation-dialog>
}